import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const modalStyles = makeStyles(({ palette, colors, spacing }: Theme) => createStyles({
  modal: {
    border: `2px solid ${colors.border}`,
    minHeight: '50vh',
  },
  closeButton: {
    color: palette.grey[500],
  },
  title: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: 24,
    letterSpacing: 0.31,
    fontFamily: 'Montserrat',
    fontWeight: 500,
    maxWidth: 'calc(100% - 97px)',
  },
  header: {
    padding: '20px 24px',
  },
  dialogContent: {
    padding: spacing(3),
  },
  cancelButton: palette.cancelAction,
  buttonIcon: {
    width: 18,
    height: 18,
    marginRight: 4,
  },
  buttonText: {
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: 600,
    letterSpacing: '0.21px',
    textTransform: 'none',
    paddingLeft: '0.25em',
    lineHeight: 'initial',
  },
  panelButton: {
    height: 36,
    minWidth: 120,
    '& > span:first-child': {
      paddingTop: '2px',
      paddingBottom: '2px',
    },
  },
  removeButton: {
    color: '#FFF',
    background: palette.buttonSingle.color,
    '&:hover': {
      backgroundColor: palette.buttonSingle.color,
    },
  },

  icon: {
    color: palette.icons.default,
    fontSize: '1rem',
  },
}), { name: 'ModalInstruction' });

export const selectStyles = makeStyles(({ palette, spacing }: Theme) => createStyles({
  root: {
    width: '100%',
    marginTop: spacing(2),
    '&:before': {
      borderBottomColor: palette.input.borderBottomColor,
    },
    '&&:hover:before': {
      borderBottomColor: palette.input.borderBottomColor,
    },
    '&:after': {
      borderBottomColor: palette.menuAction.selected,
    },
    '&$focused:after': {
      borderBottomColor: palette.menuAction.selected,
    },
    '&$disabled:before': {
      borderBottomStyle: 'dashed',
    },
  },
  label: {
    '&$focused': {
      color: palette.text.secondary,
    },
  },
  focused: {},
  disabled: {},
}), { name: 'SelectInstruction' });

export const inputStyles = makeStyles(({ palette }: Theme) => createStyles({
  root: {},
  input: {},
  labelRoot: {
    fontSize: 12,
    '&$focused': {
      color: palette.text.secondary,
    },
  },
  inputUnderline: {
    '&:before': {
      borderBottomColor: palette.input.borderBottomColor,
    },
    '&&:hover:before': {
      borderBottomColor: palette.input.borderBottomColor,
    },
    '&:after': {
      borderBottomColor: palette.menuAction.selected,
    },
    '&$focused:after': {
      borderBottomColor: palette.menuAction.selected,
    },
    '&$disabled:before': {
      borderBottomStyle: 'dashed',
    },
  },
  focused: {},
  hovered: {},
  disabled: {
    color: palette.disabledInput.color,
  },
}), { name: 'InputInstruction' });

export const useStyles = makeStyles(() => createStyles({
  renderStatus: {
    fontSize: 14,
    color: '#515B6A',
  },
  loader: {
    '& *': {
      animationDuration: '1.5s !important',
      WebkitAnimationDuration: '1.5s !important',
    },
  },
}), { name: 'CommonScriptEditor' });

export const InstructionSmallImage = makeStyles(({ palette }: Theme) => createStyles({
  root: {
    overflow: 'hidden',
  },
  smallImageWrapper: {
    width: 48,
    height: 32,
    marginRight: 8,
  },
  smallImage: {
    maxWidth: 48,
    maxHeight: 32,
    margin: 'auto',
  },
  textWrapper: {
    maxWidth: 'calc(100% - 56px)',
  },
}), { name: 'InstructionSmallImage' });

export const SliderStyles = makeStyles(({ palette }: Theme) => createStyles({
  root: {
    color: '#01B3C5',
  },
  trackInverted: {
    background: 'rgba(81,91,106,0.5)',
  },
  rail: {
    background: 'rgba(81,91,106,0.5)',
  },
  thumb: {
    '&:focus,&:hover': {
      boxShadow: 'inherit',
    },
  },
  title: {
    fontSize: 12,
    color: '#515B6A',
  },
}), { name: 'InstructionSlider' });
